// extracted by mini-css-extract-plugin
module.exports = {"featureButton":"FeaturesSection_featureButton__IsXOv"};